import {
    Box,
    Divider
} from '@mui/material';
import { Link } from 'react-router-dom';

function BuyLoggedInDescription() {
    return (
        <>
            <Box
                sx={{
                    width: '90%',
                    textAlign: 'left',
                    padding: '30px 0 10px 10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                }}>
                <Link to='/buy'>
                <img src='/img/back_button_black.png' />
                </Link>
                <Box
                    sx={{
                        margin: '25px 0 0 10px',
                        fontSize: '22px'
                    }}>
                    쿠폰이란?
                </Box>
            </Box>
            <Divider />
            <Box
                sx={{
                    background: '#f1f2f2',
                    margin: '20px',
                    padding: '20px',
                    borderRadius: '5px'
                }}>
                <Box
                    sx={{
                        fontWeight: 'bold'
                    }}>
                    클래스 쿠폰이란?
                </Box>
                <br></br>
                <Box
                    sx={{
                        fontSize: '14px'
                    }}>
                    수업 예약을 하기 위해 필요한 쿠폰입니다.
                    <br></br>
                    수업예약 창에서 수업 예약 시 사용할 수 있으며,
                    <br></br>
                    <br></br>
                    클래스 쿠폰 취소는 수업 시작 1일 전까지 가능합니다.
                    <br></br>
                    {/* <br></br>
                    ※ 예외사항
                    <br></br>
                    불가피한 사고(천재지변, 질병, 사고)에 의해 출석이 불가능한 경우,
                    클래스 쿠폰 반환 절차에 따라 관련 증빙서류 제출 시 반환신청을 할 수 있습니다. */}
                </Box>
                {/* <br></br>
                <br></br>
                <Box
                    sx={{
                        fontWeight: 'bold'
                    }}>
                    패스 쿠폰이란?
                </Box>
                <br></br>
                <Box
                    sx={{
                        fontSize: '14px'
                    }}>
                    수업시간 외에 센터 이용을 위한 쿠폰입니다.
                    <br></br>
                    홈 화면 문열기 버튼을 누르면 자동 차감됩니다.
                    <br></br>
                    <br></br>
                    기한이 지나도 환불은 불가능합니다.
                </Box> */}
            </Box>
        </>
    )
}

export default BuyLoggedInDescription;